<template>
    <div>
        <v-dialog 
            v-model="display"
            width="500"
            persistent>
            <v-card flat>
                <v-card-title>
                    {{ title }}
                </v-card-title>
                <div class="text-center" v-if="loading.data">
                    <v-progress-circular
                        indeterminate>
                    </v-progress-circular>
                </div>
                <v-card-text v-else>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="$t('name')"
                            v-model="form.name"
                            :rules="rules.name">
                        </v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="loading.data || !valid || loading.submit"
                        :loading="loading.submit"
                        @click="submit"
                        >
                        {{ $t("save_btn" )}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import AlertDialog from '@/components/common/AlertDialog';
import { mapState, mapActions } from 'vuex';
export default {
    name: "CastTypeDialog",
    components: {
        RetryDialog,
        AlertDialog
    },
    data() {
        return {
            display: false,
            openParams: null,
            valid: false,
            mode: {
                edit: false
            },
            loading: {
                data: true,
                submit: false
            },
            form: {
                id: null,
                name: null,
            },
            rules: {
                name: [
                    v => !!v || this.$t("rules_required")
                ]
            }
            
        }
    },
    computed: {
        ...mapState("sales/castType", ["castType"]),
        title() {
            if(!this.mode.edit) return this.$t('new_cast_type')
            else return this.$t('edit_cast_type')
        }
    },
    methods: {
        ...mapActions("sales/castType", ["fetchCastTypes", "fetchCastType", "storeCastType", "updateCastType"]),
        ...mapActions('common/snackBar', ["setSnackBars"]),
        open(params) {
            this.mode.edit = params.editMode;
            this.openParams = params;
            this.loading.data = true;
            this.openDataFetch();
            this.display = true;
        },
        async openDataFetch() {
            try {
                if(this.mode.edit) {
                    await this.fetchCastType(this.openParams.id);
                    this.form = JSON.parse(JSON.stringify(this.castType));
                }
                this.loading.data = false;

            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({target: "openDataFetch", message});
            }
        },
        submit() {
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeCastType(this.form)
                    .then(() => {
                        this.close();
                        this.fetchCastTypes();
                        this.setSnackBars({color: "success", message: this.$t("record_save_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })
            } else {
                this.updateCastType(this.form)
                    .then(() => {
                        this.close();
                        this.fetchCastTypes();
                        this.setSnackBars({color: "success", message: this.$t("record_update_success")});
                    })
                    .catch((error) => {
                        this.loading.submit = false;
                        let message = error.response ? error.response.data.message : error;
                        this.setSnackBars({color: "error", message});
                    })

            }
        },
        onRetryDialogSubmit(params) {
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close();
            }
        },
        close() {
            Object.assign(this.$data, this.$options.data.apply(this));
            this.$refs.form.resetValidation();
        }
    }
}
</script>